export const insightsEnabledForManufacturer = [
    '60d9bf621f9e1800128b5f89',
    '5d4a7affc58f9e001276c463',
    '66bb5a4631c861620b819776',
    '5d3195965762d100125f27b7',
    '5faa59c68e8ef90010e288bf',
    '64b14368c34b62a89a84a3b0',
    '5d31ac21f7b69f0012b61f66',
    '5f8453796a56db001018ba09',
    '66d1c6c9e503fad993499f18',
    '62ff6324db564d70f7c0284d',
    '61f1111beb8b8800125c0964',
    '60ddc53c57d9ee0011fc9aa7',
    '5d4c1699a799c500128b8b5e',
    '6343e373e0182a6de0de979a',
    '60cc8c76b1a491001244d6b2',
    '635a9864487975d0555d6de0',
    '5f8452ed1d7f960010d13001',
    '56f06fd67136bd4a7d42c534',
    '628c880268ccf02f6679001b',
    '66019342569304b8033c1e65',
    '572742b20319d9ec0c3709b1',
    '56f06e1d7136bd4a7d42c52a',
    '5eba6d9ded9a7c0010ab233c',
    '631864b0123074f4aa85644c',
    '5b2ce5ea9213987fae486ed8',
    '63497442e0182a6de0e2108c',
    '5e4d05f7ba80370011c93f95',
    '611cc8f8d3334000131fac1f',
    '5eb3f5cce1791b001650b6fb',
    '670935bb562569f0a9de6fc5',
    '633436eae0182a6de0d72646',
    '61483be2143a160014280ffb',
    '66911f3c3cc54f18a311c07a',
    '5f75cea4c29675001065333d', // IOS by MAICA GmbH
    '6332ace7487975d05549570c',
    '5d1b64fe79d00c0012d795ab',
    '65fd670d006bd98374cc2b5a',
    '5b0d3d77a9a80b4f882ca107',
    '5c740612609de70012332048',
    '65e720491731d5e8f430463f',
    '61af5a6c8d959f00136f5e11',
    '63355074e0182a6de0d7bf03',
    '6253d6e6b9e545cc7108f054',
    '665d8fb46c456ded1c6303db',
    '56f074af7136bd4a7d42c550',
    '63454512e0182a6de0df6dd9',
    '64ec9fe6e3fd06410272380c',
    '5811a354a793918a0d034dbc',
    '6272345e68ccf02f666c3193',
    '608278fe322aeb0010cccd7f',
    '65b232013af40f2e9d937038',
    '60d44d1b569bf6001137a950',
    '62581bd2b9e545cc710c8a5c',
    '58075e99f5515c9431eca83e',
    '657abe3f04be92b7b6d7be6a',
    '60d4525c81045e0012b74494',
    '5f1a9793257cd20010fc0719',
    '62de6f2739f1a4ab90200ba2',
    '641dc5ccb78d0ac9c3bb8d3c',
    '60f6b6451fc03500117fc86c',
    '5f17e414d53a7800128849c3',
    '56f075c37136bd4a7d42c557',
    '603e36db767d840010403ccb',
    '624edefab9e545cc71063f25',
    '58b02d0955caa73c6207f2f9',
    '5e3d7e37a0e17a00103e530b',
    '64b15f233f1582f20e302b92',
    '5ce6826aaa7bb50012db572a',
    '5c091ec4b0ae350010ee749f',
    '65f95736569304b803373a77',
    '56f074057136bd4a7d42c54b',
    '5d2dd51dcfbf7c0012b05af5',
    '60eee6861709ec00119d0b78',
    '60a2254dc312330012ba1107',
    '5d288197b7baf600122be04e',
    '5e6215ccf15e4b001061968d',
    '5d9c76aea21a9c0012971237',
    '5f3bc8968532c30011b8e245',
    '62385062b9e545cc71f6f796',
    '56f06ce87136bd4a7d42c525',
    '571de6d54947530e0d765e6d',
    '57a208904fd908120d61bd95',
    '57fdff80afec9c1c0e09d344',
    '5b040ebefa61161096981654',
    '665ee0d1f0845b7a32bdc387',
    '5a33d6badc0a7b158c741911',
    '660c1630569304b8034169c7',
    '59528efa963a919f54709e59', // Desoto
    '56f074af7136bd4a7d42c550', // Brax
    '64b14368c34b62a89a84a3b0', // Dreamstar
    '6154843334137500117771bf', // labeldot
    '6059ddb35935430011fce10e', // Josh V
    '56f06aa57136bd4a7d42c521', // FC Dev+Manufacturer,
    '599d69df2cc5952517edec51', // Brand: Lieblingsstück - Organization: Lovely Brands 24! GmbH & Co. KG
    '681cc31ab71efe7f430914de', // Brand: Carlo Lanza - Organization: Carlo Lanza BV
    '5ccae54d3c973600126f7747', // Brand: Pure / Hatico
    '68396d4d7009adc0d76ebd83', // MalesLions
    '68b6acb0bf714dfc9beaf399', // Croyez
    '68b6ac8ebf714dfc9beaf38a', // duquezzi
    '6181b7065fe02700119def6c', // Scoretex GmbH,
    '5787394dcf5e5fe90cb005e8', // REAL GUYS by J.PLOENES - Organization: Hans Ploenes GmbH
    '67ab34f391b9c7bb22b9d9c9', // Stylestore.com A/S
    '63d125cb9bdcde7e3aa224cf', // Aímée the Label
    '68f7322d4cce586bbe59a83d', // by-bar
    '598c0d52fe4660ab17665dac', // Riani
    '67e45bb61674ca2193d20cd1', // Deblon
    '58aed50101b252a60c0df52d', // Via Appia
    '5ce53afd223fad0012bb2075', // Dstrezzed
    '692945e8d1ecb9039948f48c', // Aeden official BV
    '69e61743e499b1c9b8b5357c', // District Indigo
    '619b4bbf8714cf0011284ee9', // Hugo Boss
    '6a1fdde8ad695e3cae30d868', // Pepe Jeans
    '698470eb83e309ae3a4a65bb', // Stieglitz
    '69c255d136f8aa6280010a47', // GABBA
    '699ec3c95ed556f5aa371289', // Secrid
    '6a4f86f2966aa9a73b6f2b85', // Triad'Oro
    '5bf2ce9422fdc40010afc9c8' // Gabor Shoes GmbH
];
